import { createBrowserRouter, Navigate } from 'react-router';
import { Layout } from './components/Layout/Layout.jsx';
import { Home } from './components/Home/Home.jsx';
import { Events } from './components/Events/Events.jsx';
import { Facilities } from './components/Facilities/Facilities.jsx';
import { FacilityDetail } from './components/FacilityDetail/FacilityDetail.jsx';
import { Bookings } from './components/Bookings/Bookings.jsx';
import { BookingCalendar } from './components/Booking-calender/BookingCalendar.jsx'; // booking calander
import { Admin } from './components/Admin/Admin.jsx';
import { Login } from './components/Login/Login.jsx';
import { Register } from './components/Register/Register.jsx';
import { CreateEvent } from './components/CreateEvent/CreateEvent.jsx';
import { CreateFacility } from './components/CreateFacility/CreateFacility.jsx';
import { EditFacility } from './components/EditFacility/EditFacility.jsx';
import { EditEvent } from './components/CreateEvent/EditEvent.jsx';
import { EventDetail } from './components/EventDetail/EventDetail.jsx';
import { MyEvents } from './components/MyEvents/MyEvents.jsx';
import { EventAttendees } from './components/EventAttendees/EventAttendees.jsx';
import { PaymentPage } from './components/PaymentPage/PaymentPage.jsx';
import { NotFound } from './components/NotFound/NotFound.jsx';
import { Profile } from './components/Profile/Profile.jsx';
import { Community } from './components/Community/Community.jsx';

export const router = createBrowserRouter([
  {
    path: '/login',
    Component: Login,
  },
  {
    path: '/register',
    Component: Register,
  },
  {
    path: '/payment',
    Component: PaymentPage,
  },
  {
    path: '/',
    Component: Layout,
    children: [
      {
        index: true,
        element: <Navigate to="/home" replace />,
      },
      {
        path: 'home',
        Component: Home,
      },
      {
        path: 'events',
        Component: Events,
      },
      {
        path: 'my-events',
        Component: MyEvents,
      },
      {
        path: 'facilities',
        Component: Facilities,
      },
      {
        path: 'facility/:id',
        Component: FacilityDetail,
      },
      {
        path: 'bookings',
        Component: Bookings,
      },
      {
        path: 'booking-calendar', //booking calander
        Component: BookingCalendar,
      },
      {
        path: 'profile',
        Component: Profile,
      },
      {
        path: 'community',
        Component: Community,
      },
      {
        path: 'admin',
        Component: Admin,
      },
      {
        path: 'create-event',
        Component: CreateEvent,
      },
      {
        path: 'create-facility',
        Component: CreateFacility,
      },
      {
        path: 'edit-facility/:id',
        Component: EditFacility,
      },
      {
        path: 'edit-event/:id',
        Component: EditEvent,
      },
      {
        path: 'event/:id',
        Component: EventDetail,
      },
      {
        path: 'event/:id/attendees',
        Component: EventAttendees,
      },
      {
        path: '*',
        Component: NotFound,
      },
    ],
  },
]);